import { useContext } from 'react';

// screen
import { TabsDataContext } from 'modules/context';

export const useTabsData = () => {
  const context = useContext(TabsDataContext);
  if (!context) {
    throw new Error('useTabsData must be used within a TabsDataProvider');
  }
  return context;
};
